import weDeliverCollageLargeSrc from '@images/marketing/HIW-Hero1.jpg';
import weDeliverCollageSmallTopSrc from '@images/marketing/HIW-Hero2.jpg';
import weDeliverCollageSmallBottomSrc from '@images/marketing/HIW-Hero3.jpg';
import productListingCollageLargeSrc from '@images/marketing/PLPs/Collage-Large.jpg';
import productListingCollageSmallBottomSrc from '@images/marketing/PLPs/Collage-SmallBottom.jpg';
import productListingCollageSmallTopSrc from '@images/marketing/PLPs/Collage-SmallTop.jpg';
export var weDeliverFeaturetteSectionContent = {
    headline: 'We Deliver Dog Food to Dog Foodies',
    ctaUrl: '/profile',
    subhead: 'No more bulky bags, confusing serving sizes and meals that don’t have your dog’s nutrition and tastes in mind.  Nom Nom brings exactly what they need directly to your door.',
    images: [
        {
            src: weDeliverCollageLargeSrc,
            alt: 'A Basset Hound eating Nom Nom dog food from a bowl',
        },
        {
            src: weDeliverCollageSmallTopSrc,
            alt: 'A packed box of Nom Nom dog food',
        },
        {
            src: weDeliverCollageSmallBottomSrc,
            alt: 'Pink bowl of Nom Nom dog food with a pink background',
        },
    ],
};
export var productListingCollageHeroSection = {
    headline: 'Now This Is Dog Food',
    buttonLabel: 'Get Started',
    ctaUrl: '/profile',
    subhead: 'Premium proteins and vibrant veggies. Balanced nutrition and enticing variety. What you get is a dog that’s actually excited about dinner.',
    images: [
        {
            src: productListingCollageLargeSrc,
            alt: 'A yellow bowl of Nom Nom dog food',
        },
        {
            src: productListingCollageSmallTopSrc,
            alt: 'A headshot of a happy Australian Shepherd with an orange background',
        },
        {
            src: productListingCollageSmallBottomSrc,
            alt: 'A Dachshund eating Nom Nom dog food from a pink bowl',
        },
    ],
};
